/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { loadingProfileConfig } from '../../config/loading.config';
export interface ILoadingMyProfilePluginMethods extends IPluginMethodMap {
  getLoadingMyProfileSync(args?: any): any;
}

export class LoadingMyProfilePlugin implements IAgentPlugin {
  readonly methods: ILoadingMyProfilePluginMethods;

  constructor() {
    this.methods = {
      getLoadingMyProfileSync: this.getLoadingMyProfileSync.bind(this),
    };
  }

  getLoadingMyProfileSync(args?: any) {
    return {
      loading: loadingProfileConfig,
    };
  }
}
